import axios from '@/api/config';

const teacher = {
  getTeacherById(data) {
    return axios.get(`${process.env.BASE_URL}/teacher/getTeacher/` + data, {});
  },
  getTeacher(data) {
    return axios.get(`${process.env.BASE_URL}/teacher/getTeacher`, {params: data});
   },
  getTeacherList(data) {
    return axios.get(`${process.env.BASE_URL}/teacher/getTeacherList`, {params: data});
  },
  getTeacherTree(data) {
    return axios.get(`${process.env.BASE_URL}/teacher/getTeacherTree`, {params: data});
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/teacher/pageList`, data);
  },
  addTeacher(data) {
    return axios.post(`${process.env.BASE_URL}/teacher/addTeacher`, data);
  },
  teacherPageList(data) {
    return axios.post(`${process.env.BASE_URL}/agentUserInfo/teacherPageList`, data);
  },
  updateTeacher(data) {
    return axios.put(`${process.env.BASE_URL}/teacher/updateTeacher`, data);
  },
  deleteTeacher(data) {
    return axios.delete(`${process.env.BASE_URL}/teacher/deleteTeacher`,  {data: data});
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/teacher/exportExcel`, {params: data});
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/teacher/importData`, data);
  }
}

export default teacher;



// WEBPACK FOOTER //
// ./src/api/teacher.js